import { createAction } from "@reduxjs/toolkit";

export const incomingNotification = createAction<any>("notification/incoming");
